import { render, staticRenderFns } from "./EditDiscipleshipGroupModal.vue?vue&type=template&id=d39f1ae8&"
import script from "./EditDiscipleshipGroupModal.vue?vue&type=script&lang=js&"
export * from "./EditDiscipleshipGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports